var _filter, _filter2, _filter3, _filter4, _linearGradient, _linearGradient2, _mask, _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 89,
    viewBox: "0 0 91 89",
    width: 91,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 92.1873,
    width: 80.0491,
    x: -12.0491,
    y: -5.35938
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_499"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_499",
    mode: "normal",
    result: "shape"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "b",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 41,
    width: 59,
    x: 4.34473,
    y: 44.0137
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_1_499",
    stdDeviation: 6.5
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "c",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 48,
    width: 48,
    x: 8.34473,
    y: 1.01367
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_1_499",
    stdDeviation: 7.5
  }))), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    id: "d",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 118.802,
    width: 102.882,
    x: 3.1178,
    y: -15
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_499"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_499",
    mode: "normal",
    result: "shape"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 23.9964,
    x2: 74.7199,
    y1: 45.1664,
    y2: 65.3063
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa78f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f23e2c"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 78.7167,
    x2: 22.0778,
    y1: 11.1126,
    y2: 68.3954
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "g",
    fill: "#000",
    height: 89,
    maskUnits: "userSpaceOnUse",
    width: 73,
    x: 18,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18 0h73v89h-73z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m31.108 23.966c0 12.7492 10.4327 22.9661 23.4512 22.9661 13.0138 0 23.4513-10.2169 23.4513-22.9661 0-12.7491-10.4375-22.966-23.4513-22.966-13.0185 0-23.4512 10.2169-23.4512 22.966zm58.892 48.9709c0-11.8019-16.3262-14.7546-35.4411-14.7546-19.2187 0-35.4411 3.0544-35.4411 14.8655 0 11.8019 16.3262 14.7547 35.4411 14.7547 19.2187 0 35.4411-3.0545 35.4411-14.8656z",
    fill: "#000",
    fillRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m10.0928 25.1527c0 9.7214 7.9551 17.512 17.882 17.512 9.9232 0 17.882-7.7906 17.882-17.512 0-9.7215-7.9588-17.51208-17.882-17.51208-9.9269 0-17.882 7.79058-17.882 17.51208zm44.9072 37.3399c0-8.9991-12.4491-11.2507-27.0245-11.2507-14.6546 0-27.02453 2.3291-27.02453 11.3353 0 8.9991 12.44903 11.2507 27.02453 11.2507 14.6546 0 27.0245-2.3291 27.0245-11.3353z",
    fill: "url(#e)",
    fillRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m33.8447 57.0137c8.8992 0 16.5 1.4953 16.5 7.4719 0 5.9813-7.5525 7.5281-16.5 7.5281-8.8991 0-16.5-1.4953-16.5-7.4719 0-5.9813 7.5525-7.5281 16.5-7.5281z",
    fill: "#ef5641",
    fillOpacity: 0.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m32.3447 34.0137c-4.9962 0-9-4.0039-9-9 0-4.9962 4.0038-9 9-9 4.9944 0 9 4.0038 9 9 0 4.9961-4.0056 9-9 9z",
    fill: "#ef5641",
    fillOpacity: 0.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m31.108 23.966c0 12.7492 10.4327 22.9661 23.4512 22.9661 13.0138 0 23.4513-10.2169 23.4513-22.9661 0-12.7491-10.4375-22.966-23.4513-22.966-13.0185 0-23.4512 10.2169-23.4512 22.966zm58.892 48.9709c0-11.8019-16.3262-14.7546-35.4411-14.7546-19.2187 0-35.4411 3.0544-35.4411 14.8655 0 11.8019 16.3262 14.7547 35.4411 14.7547 19.2187 0 35.4411-3.0545 35.4411-14.8656z",
    fill: "#ffac95",
    fillOpacity: 0.4,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.5592 47.9321c-13.5509 0-24.4512-10.645-24.4512-23.9661h2c0 12.1773 9.9652 21.9661 22.4512 21.9661zm24.4513-23.9661c0 13.3212-10.9051 23.9661-24.4513 23.9661v-2c12.4815 0 22.4513-9.7889 22.4513-21.9661zm-24.4513-23.966c13.5462 0 24.4513 10.6449 24.4513 23.966h-2c0-12.1771-9.9698-21.966-22.4513-21.966zm-24.4512 23.966c0-13.321 10.9003-23.966 24.4512-23.966v2c-12.486 0-22.4512 9.7888-22.4512 21.966zm24.4509 33.2163c9.5794 0 18.5777.736 25.2123 3.0054 3.323 1.1367 6.1258 2.6819 8.1061 4.7782 2.0028 2.1202 3.1227 4.7626 3.1227 7.971h-2c0-2.6925-.9209-4.8449-2.5766-6.5976-1.6782-1.7766-4.1516-3.1825-7.2995-4.2592-6.3073-2.1575-15.0295-2.8978-24.565-2.8978zm-36.4411 15.8655c0-3.2084 1.1116-5.8575 3.1047-7.9886 1.9711-2.1077 4.7637-3.6674 8.0811-4.8181 6.6229-2.2972 15.6225-3.0588 25.2553-3.0588v2c-9.5859 0-18.3068.7656-24.5999 2.9484-3.1405 1.0893-5.6047 2.5077-7.2758 4.2946-1.6492 1.7635-2.5654 3.9254-2.5654 6.6225zm36.4411 15.7547c-9.5794 0-18.5778-.7361-25.2123-3.0055-3.323-1.1366-6.1258-2.6818-8.1061-4.7782-2.0028-2.1202-3.1227-4.7626-3.1227-7.971h2c0 2.6925.9209 4.8449 2.5766 6.5976 1.6782 1.7766 4.1516 3.1825 7.2995 4.2593 6.3073 2.1574 15.0295 2.8978 24.565 2.8978zm36.4411-15.8656c0 3.2084-1.1116 5.8575-3.1047 7.9886-1.9711 2.1077-4.7637 3.6675-8.0811 4.8181-6.6229 2.2972-15.6225 3.0589-25.2553 3.0589v-2c9.5859 0 18.3068-.7656 24.5999-2.9484 3.1405-1.0894 5.6047-2.5078 7.2758-4.2947 1.6492-1.7635 2.5654-3.9253 2.5654-6.6225z",
    fill: "url(#f)",
    mask: "url(#g)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.2f53a9d6a9581f9e7963417a9b18ccc5.svg";
export { ForwardRef as ReactComponent };